import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { IAccount } from '@services/accounts.service';
import { IOrganisation } from '@services/organisation-data.service';
import { combineLatest, takeUntil, distinctUntilChanged, filter, Subject, interval, Subscription } from 'rxjs';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { CircularGaugeComponent, Legend, Gradient, Annotation } from '@syncfusion/ej2-angular-circulargauge';
import { PanelData } from '../custom-dashboard/custom-dashboard.component';
import { MatMenu } from '@angular/material/menu';
import { ParseLocation } from '@angular/compiler';
import { SettingsComponent } from '@components/site-settings/settings.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	selector: 'app-dashboard-gauge',
	templateUrl: './dashboard-gauge.component.html',
	styleUrls: ['./dashboard-gauge.component.scss']
})
export class DashboardGaugeComponent implements OnChanges, OnInit, OnDestroy, AfterViewInit {

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** panelData */
	@Input() panelData: any;

	/** publicPanelData */
	@Input() publicPanelData: PanelData[];

	/** refresh */
	@Input() refresh: boolean;

	/** creating */
	@Input() creating: boolean;

	/** titleMenu */
	@Input() titleMenu: MatMenu;

	/** gauge */
	@ViewChild('gauge') gauge!: CircularGaugeComponent;

	/** panel */
	@ViewChild('panel') panel!: any;

	/** intervalFinish */
	@Output() intervalFinish = new EventEmitter<any>();

	/** Page Refresh Interval object */
	private refreshInterval: Subscription | null;

	/** refreshTime */
	private refreshTime: number = 0.5;

	/** tsRefreshTime */
	private tsRefreshTime: number = 0.05;

	/** axisConfig */
	public axisConfig: { min: number, max: number, interval: number } = { min: 0, max: 9, interval: 1.5 };

	/** localPanelData */
	public localPanelData: PanelData[] = [];

	/** labelStyle */
	public labelStyle: any = {
		offset: -10,
		position: "Outside"
	}

	/** legendSettings */
	public legendSettings: Object = {
		visible: false,
		position: 'Bottom'
	};

	/** narrowPanel */
	public narrowPanel: boolean = false;

	/** gaugeRanges */
	public gaugeRanges: { start: number, end: number }[] = [
		{ start: 0, end: 30 },
		{ start: 30, end: 70 },
		{ start: 70, end: 100 }
	];

	/** isNewGauge */
	public isNewGauge: boolean = false;

	public titleStyle: Object = { fontFamily: 'inherit' };
	public title: string = 'Progress Tracker';

	public lineStyle: Object = {
		width: 0
	};

	public labelStyleNew: Object = {
		position: 'Inside', useRangeColor: true,
		font: { size: '0px', fontFamily: 'inherit' }
	};

	public ranges: Object[] = [
		{
			start: 0, end: 100,
			radius: '90%',
			startWidth: 20, endWidth: 20,
			color: '#E0E0E0',
			roundedCornerRadius: 20
		},
	];

	public pointers: Object[] = [{
		roundedCornerRadius: 20,
		value: 10,
		type: 'RangeBar',
		radius: '90%',
		color: '#e5ce20',
		border: {
			width: 0
		},
		animation: {
			enable: false
		},
		pointerWidth: 30
	}];

	public majorTicks: Object = {
		height: 0,
	};

	public minorTicks: Object = {
		height: 0
	};

	public annotations: Object = [{
		description: 'RangeBar pointer value from the slider',
		content: '<div id="pointervalue" style="font-size:35px;width:120px;text-align:center;">' +
			'30</div>',
		angle: 0,
		zIndex: '1',
		radius: '0%'
	}];

	/** margin */
	public margin: Object = { left: 0, right: 0, top: 0, bottom: 0 };

	/** defaultRangeColours */
	public defaultRangeColours: string[] = ["green", "orange", "red"];

	/** currentBorderColour */
	public currentBorderColour: string = "";

	/** indexColours */
	public indexColours: { colour: string, score: number, border: boolean }[] = [];

	/** borderChange */
	@Output() borderChange = new EventEmitter<string>();

	/** testingValue */
	@Input() public testingValue: number = 4;

	/** liveTimestamps - Git#135
	 *  array[panelID][gaugeID]
	 */
	public liveTimestamps: { html: SafeHtml, offline: boolean }[][] = [];

	/** timestampInterval - Git#135 */
	private timestampInterval: Subscription | null;

	/** OFFLINE_THRESHOLD - Git#135 - in minutes */
	private OFFLINE_THRESHOLD: number = 10;

	/**
	 * Default Constructor
	 * @param globalFunctions globalFunctions  
	 * @param siteSubscriptions siteSubscriptions 
	 * @param document document 
	 * @param vcr vcr 
	 */
	constructor(
		public globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private vcr: ViewContainerRef,
		private sanitizer: DomSanitizer
	) {
		/** Get required subscriptions */
		// combineLatest([
		// 	this.siteSubscriptions.selectedOrganisation$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
		// ]).pipe(
		// 	// Ensure that subscriptions are not null or undefined
		// 	filter(([selectedAccount]) => !!selectedAccount)
		// ).subscribe({
		// 	next: ([selectedAccount]) => {
		// 	},
		// 	error: (error) => {
		// 		this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
		// 	}
		// });
	}

	/**
	 * ngAfterViewInit
	 */
	ngAfterViewInit(): void {
		// if (!this.creating) {
		this.getPanelWidth();
		// }
	}

	/**
	 * getPanelWidth
	 */
	getPanelWidth() {
		if (this.panel) {
			if (!this.creating) {
				this.setMinMaxInterval();
				this.setGaugeRanges();
			}
			setTimeout(() => {
				if (this.panel.nativeElement.offsetWidth <= 350) {
					this.narrowPanel = true;
					setTimeout(() => {
						this.respondToRefreshOLD();
					}, 0);
				}
			}, 0);
		} else {
			setTimeout(() => {
				this.getPanelWidth();
			}, 100);
		}
	}

	/**
	 * ngOnInit
	 */
	ngOnInit(): void {
		this.refreshInterval = interval((this.refreshTime * 60000)).pipe(takeUntil(this.finalise)).subscribe(() => {
			this.intervalFinish.emit(this.panelData);
		});

		this.timestampInterval = interval((this.tsRefreshTime * 60000)).pipe(takeUntil(this.finalise)).subscribe(() => {
			this.setGaugeLiveTimestamps();
		});

		if (this.panelData) {
			this.labelStyle.font = { color: this.panelData.textColour };
		}
		// this.setUpObserver();
	}

	/**
	 * setUpObserver
	 */
	setUpObserver() {
		if (this.gauge) {
			const observer = new ResizeObserver(entries => {
				if (this.gauge) {
					for (const entry of entries) {
						const height: number = entry.contentRect.height ?? 0;
						const width: number = entry.contentRect.width ?? 0;

						const title: HTMLElement | null = <HTMLElement>entry.target.getElementsByClassName("text-panel-title")[0];

						this.gauge.height = `${(!title ? height : height - title.offsetHeight) * 1}px`;
						this.gauge.width = `${width}px`;
						// this.gauge.refresh();
					}
				}
			});
			let parent: HTMLElement | null = this.gauge.element;
			let panel: HTMLElement | undefined = undefined;
			while (parent) {
				if (parent.classList.contains("panel-host")) {
					panel = parent;
					parent = null;
					break;
				} else {
					parent = parent.parentElement;
				}
			}
			if (panel) {
				observer.observe(panel);
			}
		} else {
			setTimeout(() => {
				this.setUpObserver();
			}, 100);
		}
	}

	/**
	 * ngOnChanges
	 * @param changes changes  
	 */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["refresh"] && changes["refresh"].currentValue == true) {
			this.respondToRefresh();
		}
		if (changes["publicPanelData"]) {
			this.localPanelData = this.publicPanelData;
		}
	}

	/**
	 * destroyPanel
	 */
	destroyPanel() {
		this.finalise.next();
		this.finalise.complete();
		if (this.refreshInterval) {
			this.refreshInterval.unsubscribe();  // Clear the interval if it's set
			this.refreshInterval = null;  // Reset to null to prevent memory leaks
		}
	}

	/**
	 * ngOnDestroy
	 */
	ngOnDestroy(): void {
		// console.log("Destroying");
		this.destroyPanel();
	}

	/**
	 * respondToRefresh
	 */
	respondToRefreshOLD() {
		if (this.gauge) {
			let parent: HTMLElement | null = this.gauge.element;
			let panel: HTMLElement | undefined = undefined;
			while (parent) {
				if (parent.classList.contains("panel-host")) {
					panel = parent;
					parent = null;
					break;
				} else {
					parent = parent.parentElement;
				}
			}
			if (panel) {
				const height: number = panel.offsetHeight ?? 0;
				const width: number = panel.offsetWidth ?? 0;

				const title: HTMLElement | null = <HTMLElement>panel.getElementsByClassName("text-panel-title")[0];

				this.gauge.height = `${(!title ? height : height - title.offsetHeight) * 0.8}px`;
				this.gauge.width = `${width}px`;

				if (!this.creating && this.publicPanelData) {
					let axis = this.gauge.axes[0];
					const panelData = this.publicPanelData[parseInt(panel.id ?? '')];
					if (panelData) {
						axis.maximum = panelData.max ? panelData.max : 10;
						axis.minimum = panelData.min ? panelData.min : 0;
						axis.majorTicks!.interval = panelData.interval;
					}
				}
				// this.gauge.refresh();
			}
		}
	}

	/**
	 * respondToRefresh
	 */
	respondToRefresh() {
		this.setMinMaxInterval();
		this.setGaugeRanges();
		if (this.gauge) this.gauge.refresh();
		if (this.narrowPanel) {
			this.respondToRefreshOLD();
		}
	}

	/**
	 * setMinMaxInterval
	 * @returns 
	 */
	setMinMaxInterval() {
		if (!this.creating && this.publicPanelData) {
			const panelData = this.publicPanelData[parseInt(this.panelData.id ?? '')];
			if (panelData) {
				// this.axisConfig = { min: panelData.min ?? 0, max: panelData.max || 100, interval: panelData.interval || 25 };
				const max = this.panelData.gaugeValueType == 1 ? this.panelData.accumulationMax ?? 100 : panelData.max;
				this.axisConfig = { min: 0, max: max || 100, interval: panelData.interval || 25 };
			}
		}
	}

	/**
	 * setGaugeRanges
	 */
	setGaugeRanges() {
		if (!this.creating) {
			this.gaugeRanges = this.getGaugeRanges();
		}
	}

	/**
	 * getGaugeRange
	 * @returns 
	 */
	getGaugeRanges(): { start: number, end: number }[] {
		let result: { start: number, end: number }[] = [];
		const data = this.publicPanelData[this.panelData.id];
		if (data && data.max != undefined && data.min != undefined) {
			const max = this.panelData.gaugeValueType == 1 ? this.panelData.accumulationMax ?? 100 : data.max;
			const min = this.panelData.gaugeValueType == 1 ? 0 : data.min;
			if (min != undefined && max != undefined) {
				result.push({
					start: 0,
					end: parseFloat((max * 0.3).toFixed(1))
				});
				result.push({
					start: parseFloat((max * 0.3).toFixed(1)),
					end: parseFloat((max * 0.7).toFixed(1))
				});
				result.push({
					start: parseFloat((max * 0.7).toFixed(1)),
					end: parseFloat((max).toFixed(1))
				});
			}
		} else {
			const max = this.panelData.gaugeValueType == 1 ? this.panelData.accumulationMax ?? 100 : this.gaugeRanges[this.gaugeRanges.length - 1].end;
			const min = this.panelData.gaugeValueType == 1 ? 0 : this.gaugeRanges[0].start;
			result.push({
				start: 0,
				end: parseFloat((max * 0.3).toFixed(1))
			});
			result.push({
				start: parseFloat((max * 0.3).toFixed(1)),
				end: parseFloat((max * 0.7).toFixed(1))
			});
			result.push({
				start: parseFloat((max * 0.7).toFixed(1)),
				end: parseFloat((max).toFixed(1))
			});
		}
		return result;
	}

	/**
	 * getDefaultRangeColour
	 * @param range range 
	 */
	getDefaultRangeColour(range: any, index: number, rangeIdx: number): string {
		let result: string = "";
		if (!range.name[index]) {
			result = this.defaultRangeColours[rangeIdx];
		} else if (["Low", "Normal", "High"].includes(range.name[index])) {
			switch (range.name[index]) {
				case "Low":
					result = this.defaultRangeColours[0];
					break;
				case "Normal":
					result = this.defaultRangeColours[1];
					break;
				case "High":
					result = this.defaultRangeColours[2];
					break;
			}
		}
		return result;
	}

	/**
	 * getAxisMaxMinForRanges
	 */
	getAxisMaxMinForRanges(index: number): { min: number, max: number, interval: number } {
		if (this.panelData.ranges && this.panelData.ranges[0].min[index] != undefined) {
			let min: number = Math.min(...this.panelData.ranges.map((x: any) => x.min[index]).filter((x: number) => x != null && x != undefined));
			let max: number = Math.max(...this.panelData.ranges.map((x: any) => x.max[index]).filter((x: number) => x != null && x != undefined));
			return { min: min, max: max, interval: max - min };
		} else {
			return { min: this.axisConfig.min, max: this.axisConfig.max, interval: this.axisConfig.interval };
		}
	}

	/**
	 * resolveRangeColour
	 * @param value value 
	 * @param index index 
	 * @returns 
	 */
	resolveRangeColour(value: number, index: number): string {
		if (this.panelData.ranges && this.panelData.ranges[0].min[index] != undefined) {
			let result: string = "";
			let newBorderColour: string = "";
			let score: number = 0;
			let border: boolean = false;
			const rangeValues = this.panelData.ranges.map((x: any) => [x.min[index], x.max[index]]);
			if (value <= rangeValues[0][1]) {
				const range = this.panelData.ranges[0];
				result = range.color[index] || this.getDefaultRangeColour(range, index, 0);
				score = 1;
				border = range.createsBorder[index];
			} else if (value >= rangeValues[1][0] && value <= rangeValues[1][1]) {
				const range = this.panelData.ranges[1];
				result = range.color[index] || this.getDefaultRangeColour(range, index, 1);
				score = 2;
				border = range.createsBorder[index];
			} else if (value >= rangeValues[2][0]) {
				const range = this.panelData.ranges[2];
				result = range.color[index] || this.getDefaultRangeColour(range, index, 2);
				score = 3;
				border = range.createsBorder[index];
			}
			this.indexColours[index] = { colour: result, score: score, border: border };
			let currentHighest: number = 0;
			let currentHighestColour: string = "";
			let shouldCreateBorder: boolean = false;
			this.indexColours.forEach((colour: any) => {
				if (colour.score > currentHighest) {
					currentHighest = colour.score;
					currentHighestColour = colour.colour;
					shouldCreateBorder = colour.border;
				}
			});
			if (this.currentBorderColour != currentHighestColour) {
				this.currentBorderColour = currentHighestColour;
				if (shouldCreateBorder) {
					this.borderChange.emit(this.currentBorderColour);
				} else {
					this.borderChange.emit('');
				}
			}
			return result;
		} else {
			return "black";
		}
	}

	/**
	 * getGaugeLiveTimestamp
	 * @param data data 
	 */
	getGaugeLiveTimestamp(data: any, index: number): { html: SafeHtml, offline: boolean } {
		let result: SafeHtml = "";
		let offline: boolean = false;
		if (data.liveTimestamp) {
			if (data.liveTimestamp[index]) {
				const epochNow = new Date().getTime();
				const diff = epochNow - data.liveTimestamp[index];
				const minutes = parseFloat(((diff / 1000) / 60).toFixed(1));
				if (minutes > this.OFFLINE_THRESHOLD) {
					offline = true;
				}
				let _result: string = ` (${minutes} min)`;
				// let _result: string = ` (${minutes} min) ${offline ? 'OFFLINE' : ''}`;
				result = this.sanitizer.bypassSecurityTrustHtml(_result);
			}
		}
		return { html: result, offline: offline };
	}

	/**
	 * setGaugeLiveTimestamps
	 */
	setGaugeLiveTimestamps() {
		if (this.publicPanelData && this.publicPanelData.length > 0) {
			this.publicPanelData.forEach((panelData) => {
				if (panelData.liveTimestamp) {
					this.liveTimestamps[parseInt(panelData.id)] = [];
					for (let i: number = 0; i < panelData.liveTimestamp.length; i++) {
						const result = this.getGaugeLiveTimestamp(panelData, i);
						this.liveTimestamps[parseInt(panelData.id)][i] = result;
					}
				}
			});
		}
	}
}


CircularGaugeComponent.Inject(Legend);
CircularGaugeComponent.Inject(Gradient);
